import { render, staticRenderFns } from "./AddEditEmergency.vue?vue&type=template&id=0fd55fc1&"
import script from "./AddEditEmergency.vue?vue&type=script&lang=js&"
export * from "./AddEditEmergency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports